import React, { useState, useEffect, } from "react";
import ky from "ky";
import firebase from "firebase/app";

import "firebase/auth";
import "firebase/app-check";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import "firebase/functions"; // Adicionado para suporte a functions

const FirebaseContext = React.createContext();

const config = {
  apiKey: "AIzaSyB77PBpkZwwMvEc1VAAYfccQE9k6pLnf8Y",
  authDomain: "telemed-develop.firebaseapp.com",
  databaseURL: "https://telemed-develop.firebaseio.com",
  projectId: "telemed-develop",
  storageBucket: "telemed-develop.appspot.com",
  messagingSenderId: "852258379245",
  appId: "1:852258379245:web:c5ab796c9adf1b9eed83e4",
  measurementId: "G-0PNBJTZGVX",
};

const FirebaseProvider = ({ children }) => {
  const [firebaseConfig, setFirebaseConfig] = useState();

  useEffect(() => {
    const isDev = ["development", "test"].includes(process.env.NODE_ENV);

    if (isDev) {
      console.log("%cAmbiente: Desenvolvimento (Emuladores)", "color: red; font-weight: bold");
      setFirebaseConfig(config);
    } else {
      ky.get("/__/firebase/init.json", { retry: 3, timeout: 3000 })
        .json()
        .then(data => {
          setFirebaseConfig(data);
          console.log(`%cAmbiente: ${data.projectId}`, "color: gray; font-weight: bold");
        })
        .catch(err => {
          console.error("Erro ao carregar config remota:", err);
          setFirebaseConfig(false);
        });
    }
  }, []);

  // Inicialização das instâncias
  let firebaseApp, firebaseAuth, db, storage, realtimeDb;

  if (firebaseConfig) {
    if (!firebase.apps.length) {
      firebaseApp = firebase.initializeApp(firebaseConfig);
    } else {
      firebaseApp = firebase.app();
    }

    firebaseAuth = firebaseApp.auth();
    db = firebaseApp.firestore();
    storage = firebaseApp.storage();
    realtimeDb = firebaseApp.database();

    // Aplica emuladores se estiver em dev
    if (process.env.REACT_APP_ENV === "local") {
      const host = "localhost";

      // Configuração obrigatória para evitar erros de conexão local
      if (!window._firebaseEmulatorsApplied) {
        firebaseAuth.useEmulator(`http://${host}:9099`);
        db.useEmulator(host, 8081);
        realtimeDb.useEmulator(host, 9001);
        storage.useEmulator(host, 9199);
        firebaseApp.functions().useEmulator(host, 5001);

        // Evita que o React chame useEmulator novamente em re-renders
        window._firebaseEmulatorsApplied = true;
        console.log("⚡ Emuladores localhost conectados com sucesso!");
      }
    }

    // Settings do Firestore (deve vir após o useEmulator no v8)
    db.settings({ ignoreUndefinedProperties: true, merge: true });
  }

  const value = {
    firebaseConfig,
    firestore: firebase.firestore,
    firebaseApp,
    firebaseAuth,
    db,
    storage,
    realtimeDb,
  };

  return (
    <FirebaseContext.Provider value={value}>
      {children}
    </FirebaseContext.Provider>
  );
};

export default FirebaseContext;
export { FirebaseProvider };